import { render } from "./letter-topic-create-import.vue?vue&type=template&id=23335183"
import script from "./letter-topic-create-import.vue?vue&type=script&lang=js"
export * from "./letter-topic-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__